export function createDebouncedRunner(delayMs: number) {
	let timer: number | null = null;

	return (fn: () => void | Promise<void>): void => {
		if (timer !== null) {
			window.clearTimeout(timer);
		}

		timer = window.setTimeout(() => {
			timer = null;
			void fn();
		}, delayMs);
	};
}
